import React from 'react';

export function AddStoreIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 1024 1024"
      {...props}
    >
      <g
        transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path
          d="M1935 9270 c-127 -17 -251 -84 -348 -190 -73 -78 -100 -129 -197
-358 -233 -556 -418 -899 -777 -1435 -274 -411 -302 -476 -283 -660 28 -264
150 -489 355 -654 346 -277 845 -276 1192 2 194 156 330 400 350 633 7 81 23
98 23 23 0 -64 40 -219 79 -305 89 -196 253 -366 446 -461 335 -165 731 -122
1022 110 103 82 200 203 258 320 50 99 95 261 95 336 0 27 5 49 10 49 6 0 10
-22 10 -49 0 -27 11 -92 24 -145 150 -589 802 -889 1351 -621 284 139 496 440
522 743 7 81 23 98 23 23 0 -64 40 -219 79 -305 89 -197 254 -367 446 -461
337 -165 732 -122 1022 110 194 155 330 400 350 633 7 81 23 98 23 23 0 -64
40 -219 79 -305 89 -196 253 -366 446 -461 404 -199 890 -92 1170 258 116 145
183 311 205 503 20 183 -8 248 -284 662 -361 540 -544 877 -776 1432 -104 249
-127 289 -219 380 -78 77 -152 123 -251 157 -53 17 -172 18 -3220 19 -1741 1
-3192 -2 -3225 -6z"
        />
        <path
          d="M2155 5791 c-215 -208 -545 -351 -812 -351 l-64 0 3 -1667 3 -1668
28 -100 c108 -396 426 -669 832 -715 105 -12 4189 -14 4183 -2 -2 4 -26 54
-55 112 -66 135 -127 312 -161 470 -24 116 -26 143 -27 365 0 209 3 254 22
350 40 195 106 386 184 533 21 41 39 75 39 78 0 2 -798 5 -1772 6 l-1773 3
-50 27 c-60 32 -114 87 -146 148 l-24 45 -3 1096 -2 1096 -85 57 c-47 32 -118
89 -159 127 -41 38 -75 69 -77 69 -2 0 -40 -36 -84 -79z"
        />
        <path
          d="M7923 5801 c-40 -38 -111 -95 -158 -127 l-85 -58 0 -738 0 -739 73 8
c133 15 473 9 572 -11 201 -38 419 -113 563 -192 34 -18 65 -34 67 -34 3 0 5
344 5 765 l0 765 -64 0 c-266 0 -593 142 -811 352 -45 43 -84 78 -86 78 -2 -1
-37 -32 -76 -69z"
        />
        <path
          d="M7865 3829 c-184 -14 -415 -79 -586 -165 -282 -141 -562 -421 -703
-703 -127 -253 -187 -557 -166 -842 38 -500 304 -945 730 -1221 466 -303 1079
-335 1581 -82 282 141 562 421 703 703 188 374 221 826 90 1226 -153 464 -545
856 -1009 1009 -121 39 -254 66 -389 76 -66 5 -128 9 -136 8 -8 0 -60 -4 -115
-9z m292 -644 c68 -20 113 -53 140 -100 22 -38 23 -50 23 -282 l0 -243 238 0
c227 0 240 -1 282 -22 85 -43 120 -131 120 -298 0 -167 -35 -255 -120 -297
-42 -22 -55 -23 -282 -23 l-238 0 0 -238 c0 -227 -1 -240 -22 -282 -43 -85
-131 -120 -298 -120 -167 0 -255 35 -297 120 -22 42 -23 55 -23 282 l0 238
-238 0 c-227 0 -240 1 -282 22 -85 43 -120 131 -120 298 0 163 34 251 115 297
38 22 50 23 283 23 l242 0 0 238 c0 227 1 240 23 282 26 52 57 76 128 101 69
24 252 26 326 4z"
        />
      </g>
    </svg>
  );
}
